import * as Actions from "./actions";
import { REST_SERVICE_URL_ROOT, CLIENT_ID, CLIENT_SECRET } from '../../../../config/settings';
import { deleteState, loadState } from "../../../../store/localStorage";
import Axios from "axios";

const loginUser = (username, password, changePassword) => (dispatch) =>{
    
    let params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    params.append('grant_type', "password");
    
    return Axios.post(REST_SERVICE_URL_ROOT+"/oauth/token", params, {
        headers: { 'Authorization':"Basic "+btoa(CLIENT_ID+":"+CLIENT_SECRET) }
    }).then((response) => {
        if(!changePassword) {
            dispatch({type:'RESET'});
            document.cookie = CLIENT_ID+"="+response.data.access_token+"; path=/"
            dispatch(Actions.setUserAuth(response.data, true));  
        }        
        loadState();
        return response;
    })   
};

const changePassword = (username, nPassword, token) => () =>{
    let params = new URLSearchParams();
    params.append('username', username);
    params.append('password', nPassword);

    return Axios.post(REST_SERVICE_URL_ROOT+"/changePassword", params,{
        headers: { 'Authorization':"Bearer "+ token}
    }).then((response) => {
      return response;
    })  
}

const initialize = () => () =>{   
    return Axios.get(REST_SERVICE_URL_ROOT+"/initialize")
    .then((response) => {
        return response.data;    
    })   
};

const logoutUser = () => (dispatch) =>{
    let state = loadState();
    state && state.auth.credentials.access_token  && Axios.delete(REST_SERVICE_URL_ROOT+"/logout/"+state.auth.credentials.access_token,{
        headers: { 'Authorization':"Bearer "+ state.auth.credentials.access_token}})

    dispatch({type:'RESET'});
    document.cookie = CLIENT_ID+"=; path=/"
    deleteState();
};

const extendExpiry = () => (dispatch) =>{
    dispatch(Actions.extendTimeout())
};

const setPartnerCodes = (payload) => (dispatch) =>{
    dispatch(Actions.setPartnerCode(payload));
}

const setMobilePage = (payload) => (dispatch) =>{
    dispatch(Actions.setMobilePage(payload));
}

const setTimezoneOffset = (payload) => (dispatch) =>{
    dispatch(Actions.setTimezoneOffset(payload));
}

export {
    extendExpiry,
    loginUser, 
    logoutUser,
    changePassword,
    initialize,
    setPartnerCodes,
    setMobilePage,
    setTimezoneOffset
};
